import * as localforage from "localforage";
import { phpRequest } from "./phpRequest";

export const customersAPI = async () => {
  const data = await phpRequest.get("/company/fec-customers");
  const customers = data.fec_customers;
  await localforage.setItem("customers", customers);
  return customers;
};
